import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="brand-text">Galaxy<span className="x">X</span>on</div>
    <div style={{ marginTop: 6 }}>© {new Date().getFullYear()} — Decentralized Income Platform</div>
  </footer>
);

export default Footer;
